module.exports = __webpack_public_path__ + "img/product-7.c8d74321.png";